module.exports = __webpack_public_path__ + "static/media/August.2024 Dai Hung - Block 05.1a.2e0192a4.pdf";